/* global Metafans_JS, showNotification */

/**
 * Removes a value from a comma-separated string.
 * @param {string} list - The comma-separated string.
 * @param {string} value - The value to remove.
 * @param {string} [separator=','] - The separator character.
 * @returns {string} The new string.
 */
function removeValue(list, value, separator = ",") {
    const values = list.split(separator);
    for (let i = 0; i < values.length; i++) {
        if (values[i].trim() == value) {
            values.splice(i, 1);
            return values.join(separator);
        }
    }
    return list.trim();
}

/**
 * Handles the preview and upload of images for the activity post form.
 * @param {HTMLInputElement} input - The file input element.
 */
async function imagesPreview(input) {
    const mediaIdsInput = document.getElementById("whats-new-post-media");
    let ids = mediaIdsInput ? mediaIdsInput.value : "";

    if (input.files && input.files[0]) {
        const file = input.files[0];

        // Validate video file format
        if (file.type.startsWith("video")) {
            const supported_format = ["mp4", "webm", "mpeg", "ogg"];
            const ext = file.type.split("/")[1];
            if (!supported_format.includes(ext)) {
                showNotification("info", "Unsupported file type!");
                throw new Error("Unsupported file type!");
            }
        }

        const formData = new FormData();
        const uniqid = Date.now();
        formData.append("action", "activity_upload");
        formData.append("file_name", file.name);
        formData.append("upload_file", file);

        // Create and show loader
        const uploaderEl = document.querySelector(".previewer-uploader");
        const loaderEl = document.createElement("p");
        loaderEl.className = "media-uploading";
        loaderEl.id = uniqid;
        if (uploaderEl) {
            uploaderEl.before(loaderEl);
        }

        try {
            const response = await fetch(Metafans_JS.ajaxurl, {
                method: "POST",
                body: formData,
            });
            const data = await response.json();

            const previewEl = document.getElementById(uniqid);
            if (previewEl) {
                previewEl.classList.add("done", data.type);
                previewEl.innerHTML = data.html;

                const removeSpan = document.createElement("span");
                removeSpan.className = "remove-media";
                removeSpan.dataset.mediaId = uniqid;
                removeSpan.dataset.attachmentId = data.id;
                removeSpan.textContent = "x";
                previewEl.appendChild(removeSpan);
            }

            if (mediaIdsInput) {
                mediaIdsInput.value = ids === "" ? data.id : `${ids}, ${data.id}`;
            }

            const submitBtn = document.getElementById("aw-whats-new-submit");
            if (submitBtn) {
                submitBtn.removeAttribute("disabled");
            }
        } catch (error) {
            console.error("Media upload failed:", error);
            loaderEl.remove(); // Clean up loader on error
        }
    }
}

/**
 * Handles the removal of an uploaded media item.
 * @param {Event} e - The click event.
 */
async function handleRemoveMedia(e) {
    const removeBtn = e.target.closest(".remove-media");
    if (!removeBtn) return;

    const attachment_id = removeBtn.dataset.attachmentId;
    const mediaIdsInput = document.getElementById("whats-new-post-media");
    const ids = mediaIdsInput ? mediaIdsInput.value.trim() : "";

    const payload = new URLSearchParams({
        action: "th_bp_remove_media",
        att_id: attachment_id,
    });

    // Optimistically update UI
    if (mediaIdsInput) {
        mediaIdsInput.value = removeValue(ids, attachment_id, ",");
    }
    removeBtn.parentElement?.remove();

    try {
        await fetch(Metafans_JS.ajaxurl, {
            method: "POST",
            body: payload,
        });
        // Enable submit button
        const submitBtn = document.getElementById("aw-whats-new-submit");
        if (submitBtn) {
            submitBtn.removeAttribute("disabled");
        }
    } catch (error) {
        console.error("Failed to remove media:", error);
        // Optionally, revert UI changes here if the server call fails
    }
}

/**
 * Initializes all event listeners for media uploads.
 */
export function init() {
    document.addEventListener("click", (e) => {
        const mediaBtn = e.target.closest("#whats-new-attachments p.image, #whats-new-attachments p.video, #whats-new-attachments p.documents");
        if (mediaBtn) {
            const input = document.querySelector(".whats-new-previewer input[type='file']");
            if (!input) return;

            if (mediaBtn.classList.contains("image")) input.accept = "image/*,.svg";
            else if (mediaBtn.classList.contains("video")) input.accept = "video/*";
            else if (mediaBtn.classList.contains("documents")) input.accept = ".pdf,.doc,.docx,.xls,.xlsx,.txt,.ppt,.pptx,.zip,.css,.html,.json";

            document.querySelector(".whats-new-previewer")?.classList.toggle("previewer-toggle");
        }

        handleRemoveMedia(e);
    });

    document.addEventListener("change", (e) => {
        if (e.target.matches("#upload-media")) {
            imagesPreview(e.target);
        }
    });
}